import './Button.scss'

export function Button({ onClick, type }) {
    return (
        <div onClick={onClick} className="button">
            <img src={`svg/button-${type}.svg`} />
        </div>
    )
}